import { render, staticRenderFns } from "./DistributorSetting.vue?vue&type=template&id=4d004d76"
import script from "./DistributorSetting.vue?vue&type=script&lang=js"
export * from "./DistributorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports